import { Button } from '../../../../common/button-new';
import { ICreateButtonProps } from './order-create-button.models';
import { FormattedMessage } from 'react-intl';

export const OrderCreateButton = ({ handleClick, isFitted, onClick, to, style, text, testId }: ICreateButtonProps): JSX.Element => (
  <>
    {
      isFitted ? (
        <Button
          style={style ? style : 'outlined'}
          onClick={onClick}
          to={to}
          testId={testId ?? 'order-create-link'} // Don't remove this test id, it is used by YaMetrica
        >
          <FormattedMessage id={text ? text : 'order.create.button.label' } />
        </Button>
      ) : (
        <Button
          onClick={handleClick}
          style={style ? style : 'outlined'}
          testId={testId ?? 'order-create-button'} // Don't remove this test id, it is used by YaMetrica
        >
          <FormattedMessage id={text ? text : 'order.create.button.label' } />
        </Button>
      )
    }
  </>
);
